<div *ngFor="let section of sections" class="mt-2">
  <h2>{{ section.title }}</h2>
  <div class="section-border revision-notices-page-section">
    <div [innerHTML]="section.body | mdToHtml"></div>
    <app-revision-notices-note-section *ngIf="section.noteSections" [noteSections]="section.noteSections"></app-revision-notices-note-section>
  </div>
</div>
